// Wörterbuch der Oberfläche: eingeführte CRM-Begriffe bleiben (Lead, Smart View, Inbox, Follow-up,
// Opportunity, Custom Activity), alles andere kurz und sachlich auf Deutsch. Gehört dem Modul oberflaeche.
export const T = {
  app: "Förderzentrum CRM",
  nav: {
    inbox: "Inbox",
    leads: "Leads",
    smartViews: "Smart Views",
    opportunities: "Opportunities",
    reports: "Reports",
    gespraeche: "Gespräche",
    dubletten: "Dubletten",
    workflows: "Workflows",
    kontakte: "Kontakte",
    aktivitaeten: "Aktivitäten",
    einstellungen: "Einstellungen",
    abmelden: "Abmelden",
    keineViews: "Keine Smart Views.",
    keinePins: "Noch nichts angeheftet. Unter „Alle Smart Views“ mit der Stecknadel anheften.",
    angeheftet: "Angeheftet",
    geteilt: "Geteilt",
    eigene: "Eigene",
    alleZeigen: "Alle Smart Views",
    wenigerZeigen: "Nur angeheftete",
    mehr: "Mehr",
    weniger: "Weniger",
    viewSuchen: "Smart View suchen …",
    tasten: "Tastenkürzel",
    stufe1: "Kommt in Stufe 1",
  },
  smartViews: {
    titel: "Smart Views",
    alle: "Alle",
    alleLang: "Alle Smart Views",
    eigene: "Eigene",
    eigeneLang: "Eigene Smart Views",
    geteilt: "Geteilt",
    geteiltLang: "Geteilte Smart Views",
    andere: "Von anderen",
    andereLang: "Smart Views von anderen",
    suchen: "Smart Views durchsuchen",
    anheften: "In der Seitenleiste anheften",
    loesen: "Aus der Seitenleiste lösen",
    oeffnen: "Öffnen",
    neuerTab: "In neuem Tab öffnen",
    inClose: "In Close bearbeiten",
    privat: "Privat",
    geteiltMarke: "Geteilt",
    kontakte: "Kontakte",
    zahlNeu: "Trefferzahlen neu holen",
    anheftenHinweis: "Anheften wirkt nur hier im CRM, Close bleibt unverändert.",
  },
  stufe1: "kommt in Stufe 1",
  suche: {
    platzhalter: "Lead, Kontakt, Telefon oder E-Mail suchen",
    platzhalterKurz: "Lead, Kontakt, Telefon …",
    kurz: "Suchen",
    leer: "Keine Treffer.",
    mindestens: "Mindestens 2 Zeichen eingeben.",
  },
  login: {
    titel: "Anmelden",
    email: "E-Mail oder Login",
    passwort: "Passwort",
    bleiben: "Angemeldet bleiben (30 Tage)",
    knopf: "Anmelden",
    laeuft: "Anmeldung läuft …",
    hinweis: "Zugang wie im Mitarbeiterportal.",
  },
  theme: { hell: "Hell", dunkel: "Dunkel", system: "System" },
  laden: "Wird geladen …",
  lead: {
    anrufen: "Anrufen",
    anrufProtokollieren: "Anruf protokollieren",
    followUp: "Follow-up",
    neuLaden: "Neu aus Close laden",
    inCloseOeffnen: "In Close öffnen",
    idKopieren: "Lead-ID kopieren",
    ueber: "Über",
    aufgaben: "Follow-ups",
    opportunities: "Opportunities",
    kontakte: "Kontakte",
    customFields: "Custom Fields",
    leereFelder: "Leere Felder",
    notiz: "Notiz",
    zurueckZurListe: "Zurück zur Liste",
    naechster: "Nächster Lead",
    vorheriger: "Vorheriger Lead",
  },
  feed: {
    alle: "Alle",
    anrufe: "Anrufe",
    notizen: "Notizen",
    emails: "E-Mails",
    sms: "SMS",
    custom: "Custom Activities",
    status: "Statuswechsel",
    leer: "Keine Aktivitäten.",
    aelter: "Ältere laden",
  },
  inbox: {
    faellig: "Fällig",
    geplant: "Geplant",
    erledigt: "Erledigt",
    meine: "Meine",
    alle: "Alle",
  },
};

/** Bezeichnungen der Anruf-Ergebnisse (Close „disposition“). */
export const DISPOSITION: Record<string, string> = {
  answered: "Angenommen",
  "no-answer": "Nicht angenommen",
  "vm-answer": "Mailbox",
  "vm-left": "Auf Mailbox gesprochen",
  busy: "Besetzt",
  blocked: "Blockiert",
  error: "Fehler",
  abandoned: "Abgebrochen",
};
